export default "__VITE_ASSET__C9zAmPrt__"